package one.healthium.today.ui.models

data class DailyStepsUiModel(
    val steps: Long,
    val goal: Long,
) {
    val progress: Float
        get() = if (goal > 0) steps.toFloat() / goal else 0f
}